import React, { useContext, useEffect, useState } from "react"

import CommonContext from "@src/context"

import ClickableImage from "@components/clickableImage"
import Button from "@components/button"
import BottomButtons from "@components/bottomButtons"
import Section from "@components/section"
import En from "./superSmashBros_en"
import Zh from "./superSmashBros_zh"

import bgImage from "@images/ssb-bg.jpg"
import matchImg from "@images/season3/smash-match.png"

const SuperSmashBros = () => {
  const [en, setEn] = useState(false)
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <Button
          color={"blue"}
          onClick={() => {
            setEn(en => !en)
          }}
        >
          {en ? "查看中文版" : "English"}
        </Button>
      </div>
      {en ? <En /> : <Zh />}
      <Section title="对阵表">
        <ClickableImage className="fluidImage" src={matchImg} />
      </Section>

      <BottomButtons isEn={en}>
        {() => {
          return (
            <div className="enrollModal enrollModal-thinBtmPadding">
              <p>
                {en
                  ? "Please select the appropriate match group according to your personal time ( can only register once)"
                  : "请根据个人时间选择可参加的比赛组（不可重复报名）"}
              </p>
              <div className="enrollList">
                {[
                  {
                    name: "GROUP A",
                    date: "10.31",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/PN8RISM",
                  },
                  {
                    name: "GROUP B",
                    date: "11.1",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/xj29ut4",
                  },
                  {
                    name: "GROUP C",
                    date: "11.7",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/P5uUqVI",
                  },
                  {
                    name: "GROUP D",
                    date: "11.8",
                    time: "14 : 00",
                    link: "http://sparkidea.mikecrm.com/cdKttqR",
                  },
                ].map(({ name, date, time, link }) => {
                  return (
                    <div className="enroll" key={name}>
                      <h3>{name}</h3>
                      <h2>
                        {date}
                        <br />
                        {time}
                      </h2>

                      <Button color="blue" href={link}>
                        {en ? "Register" : "确认报名"}
                      </Button>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        }}
      </BottomButtons>
    </div>
  )
}

export default SuperSmashBros
